import type { PropsWithChildren } from "react";
import { UserImage } from "@circle-react-uikit/UserImage";
import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import type { TestimonialProperty } from "@/react/types/PaywallCustomization";
import { blobPath } from "@circle-react/helpers/urlHelpers";

export const Testimonial = ({
  visible,
  quote,
  name,
  avatar_image,
  avatar_image_url,
  headline,
  children,
}: PropsWithChildren<TestimonialProperty>) => {
  if (!visible) {
    return null;
  }

  const avatarUrl = avatar_image
    ? blobPath({
        filename: "avatar_image",
        signed_id: avatar_image,
      })
    : avatar_image_url;

  return (
    <div className="flex flex-col gap-y-3.5" data-testid="testimonial">
      {children}
      <Typography.BodySm data-testid="testimonial-quote">
        {quote}
      </Typography.BodySm>
      <div className="flex flex-row gap-x-3">
        <UserImage
          name={name || t("random")}
          src={avatarUrl}
          size="10"
          isFullRounded
        />
        <div className="flex flex-col gap-y-0.5">
          {name && name !== "" && (
            <Typography.LabelSm
              weight="semibold"
              data-testid="testimonial-name"
            >
              {name}
            </Typography.LabelSm>
          )}
          {headline && headline !== "" && (
            <Typography.BodySm data-testid="testimonial-headline">
              {headline}
            </Typography.BodySm>
          )}
        </div>
      </div>
    </div>
  );
};
